import { ColDef } from "ag-grid-community";

import { ColumnType } from "components/AgGrid/constants";

import { formatters } from "lib/agGrid";

export const InterestPreviewColId = {
  INTEREST_AMOUNT: "800d5c0b-3ece-4877-9f9e-6c1912949035",
  INTEREST_RATE: "5b75ca02-f4f8-4070-b139-ebe0526af58c",
  DAYS_OF_INTEREST: "fca205e6-f895-44bd-93ee-dfe69859561b",
  CHARGE_FROM: "25a8f73f-8c41-4e95-a651-fde9fb31c71d",
  CHARGE_TO: "b2fa385d-a220-4577-9f53-7e71aee21f7d",
} as const;

interface InterestPreviewRow {
  interestPreview: InterestPreviewData;
}

export const InterestPreviewColumnDef: Record<
  ValueInObj<typeof InterestPreviewColId>,
  ColDef<InterestPreviewRow>
> = {
  [InterestPreviewColId.INTEREST_AMOUNT]: {
    colId: InterestPreviewColId.INTEREST_AMOUNT,
    field: "interestPreview.interestToChargeCents",
    headerName: "Interest Amount",
    type: ColumnType.RIGHT_ALIGNED,
    enableValue: true,
    valueFormatter: formatters.signedCentsCreditDebitFormatter,
  },
  [InterestPreviewColId.INTEREST_RATE]: {
    colId: InterestPreviewColId.INTEREST_RATE,
    field: "interestPreview.interestRate",
    headerName: "Interest Rate",
    type: ColumnType.PERCENTAGE,
  },
  [InterestPreviewColId.DAYS_OF_INTEREST]: {
    colId: InterestPreviewColId.DAYS_OF_INTEREST,
    field: "interestPreview.daysOfInterest",
    headerName: "Days of Interest",
  },
  [InterestPreviewColId.CHARGE_FROM]: {
    colId: InterestPreviewColId.CHARGE_FROM,
    field: "interestPreview.chargeFromDate",
    headerName: "Charge From",
    type: ColumnType.DATE,
  },
  [InterestPreviewColId.CHARGE_TO]: {
    colId: InterestPreviewColId.CHARGE_TO,
    field: "interestPreview.chargeToDate",
    headerName: "Charge To",
    type: ColumnType.DATE,
  },
};
